import React from 'react';
import CompareMain from 'components/Compare/CompareMain';

const CompareTableImage = () => {
  return <CompareMain locationsViewable={6} />;
};

export default CompareTableImage;
